import { Breadcrumb, Col, Divider, Form, Layout, Row, Space, Button, Flex } from "antd";
import { Content } from "antd/es/layout/layout";
import { Info } from "components/elements";
import { InputNumber } from "components/form";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import schema from "../schemas/socialSecurityContributionSchema";
import styles from "../styles/SocialSecurityContribution.module.css";
import FormAntd from "components/form/FormProvide/FormAntd";
import { FormInputNumber } from "components/form/FormProvide";
import { useForm } from "antd/es/form/Form";

const SocialSecurityContributionEdit = ({
  isLoading = false,
  currentSocialSecurityContribution = {},
  onCancel = () => { },
  onSubmit = () => { },
}) => {
  const { t } = useTranslation();
  const [form] = useForm()

  // useEffect(() => {
  //   console.log("form.getFieldValue('lowestBaseSalary')", form.getFieldValue('lowestBaseSalary'));
  //   const lowestSubvention = Math.ceil(
  //     ((form.getFieldValue('lowestBaseSalary') || 0) * (form.getFieldValue("insurancePersonContributionRate") || 0)) / 100
  //   );
  //   form.setFieldValue('lowestSubvention', lowestSubvention);

  //   const highestSubvention = Math.ceil(
  //     ((form.getFieldValue("highestBaseSalary") || 0) * (form.getFieldValue("insurancePersonContributionRate") || 0)) / 100
  //   );
  //   form.setFieldValue('highestSubvention', highestSubvention);
  // }, []);

  return (
    <div className={styles.container}>
      <FormAntd
        form={form}
        initialValues={currentSocialSecurityContribution}
        enableReinitialize
        onFinish={onSubmit}
      // validationSchema={schema}
      >

        <Form.Item shouldUpdate={(prev, curv) => {

          return false
        }}>
          {({ getFieldValue, setFieldValue }) => {
            return (
              <Layout style={{ rowGap: "24px" }}>
                <Flex vertical>
                  <Breadcrumb items={[
                    { title: t("home.header"), href: "/" },
                    { title: t("masterdata.header"), href: "/masterdata/social_security_contribution" },
                    { title: t("social_security_contribution.header"), href: "/masterdata/social_security_contribution" },
                    { title: t("common.edit") }
                  ]} />
                  <h2>{t("common.edit")}</h2>
                </Flex>
                <Space size={24} direction="vertical">
                  <div className="card">
                    <b className={styles.infoTopic}>
                      {t("social_security_contribution.label.social_security_rate")}
                    </b>
                    <Divider />
                    <Space direction="vertical" size={24}>
                      <Row gutter={24}>
                        <Col span={12} style={{ marginBottom: "10px" }}>
                          <Info
                            label={t(
                              "social_security_contribution.label.lowest_base_salary"
                            )}
                            value={
                              <FormInputNumber
                                name="lowestBaseSalary"
                                placeholder={t(
                                  "social_security_contribution.label.lowest_base_salary"
                                )}
                                size="large"
                                min={0}
                                onChange={(value) => {
                                  const lowestSubvention = Math.ceil(
                                    ((value || 0) * (getFieldValue("insurancePersonContributionRate") || 0)) / 100
                                  );
                                  setFieldValue("lowestBaseSalary", value)
                                  setFieldValue("lowestSubvention", lowestSubvention)
                                }
                                }
                              />
                            }
                          />
                        </Col>
                        <Col span={12}>
                          <Info
                            label={t(
                              "social_security_contribution.label.highest_base_salary"
                            )}
                            value={
                              <FormInputNumber
                                name="highestBaseSalary"
                                placeholder={t(
                                  "social_security_contribution.label.highest_base_salary"
                                )}
                                size="large"
                                min={0}
                                onChange={(value) => {
                                  setFieldValue(
                                    "highestBaseSalary",
                                    value
                                  )
                                  const highestSubvention = Math.ceil(
                                    ((getFieldValue("corporateContributionRate") || 0) * (value || 0)) / 100
                                  );
                                  form.setFieldValue('highestSubvention', highestSubvention);
                                }
                                }
                              />
                            }
                          />
                        </Col>
                        <Col span={12}>
                          <Info
                            label={t(
                              "social_security_contribution.label.insurance_person_contribution_rate"
                            )}
                            value={
                              <FormInputNumber
                                name="insurancePersonContributionRate"
                                placeholder={t(
                                  "social_security_contribution.label.insurance_person_contribution_rate"
                                )}
                                size="large"
                                min={0}
                                max={100}
                                onChange={(value) => {
                                  setFieldValue(
                                    "insurancePersonContributionRate",
                                    value
                                  )
                                  const lowestSubvention = Math.ceil(
                                    ((value || 0) * (getFieldValue("lowestBaseSalary") || 0)) / 100
                                  );
                                  setFieldValue("lowestSubvention", lowestSubvention)
                                }
                                }
                              />
                            }
                          />
                        </Col>
                        <Col span={12}>
                          <Info
                            label={t(
                              "social_security_contribution.label.corporate_contribution_rate"
                            )}
                            value={
                              <FormInputNumber
                                name="corporateContributionRate"
                                placeholder={t(
                                  "social_security_contribution.label.corporate_contribution_rate"
                                )}
                                size="large"
                                min={0}
                                max={100}
                                onChange={(value) => {
                                  setFieldValue(
                                    "corporateContributionRate",
                                    value
                                  )
                                  const highestSubvention = Math.ceil(
                                    ((getFieldValue("highestBaseSalary") || 0) * (value || 0)) / 100
                                  );
                                  form.setFieldValue('highestSubvention', highestSubvention);
                                }
                                }
                              />
                            }
                          />
                        </Col>
                        <Col span={12} style={{ marginBottom: "10px" }}>
                          <Info
                            label={t(
                              "social_security_contribution.label.lowest_subvention"
                            )}
                            value={
                              <FormInputNumber
                                name="lowestSubvention"
                                placeholder={t(
                                  "social_security_contribution.label.lowest_subvention"
                                )}
                                size="large"
                                min={0}
                              />

                            }
                          />
                        </Col>
                        <Col span={12}>
                          <Info
                            label={t(
                              "social_security_contribution.label.highest_subvention"
                            )}
                            value={
                              <FormInputNumber
                                name="highestSubvention"
                                placeholder={t(
                                  "social_security_contribution.label.highest_subvention"
                                )}
                                size="large"
                                min={0}
                              />
                            }
                          />
                        </Col>
                      </Row>
                    </Space>
                  </div>
                  <Row justify="end">
                    <Flex gap={12}>
                      <Button type="default" onClick={onCancel} style={{ height: "40px", borderRadius: "8px" }}>
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button type="primary" htmlType="submit" disabled={isLoading} style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                        {t("common.save").toUpperCase()}
                      </Button>
                    </Flex>
                  </Row>
                </Space>
              </Layout>
            )
          }}
        </Form.Item>

      </FormAntd>
    </div >
  );
};

export default SocialSecurityContributionEdit;
